/* 
  1. The webchat is displayed inside an iframe, which means that its window object 
  is different from the window object of the host website
  2. To access properties and methods of the host website's window object, we need
  to use the topmost window object
  3. The topmost window object represents the highest level window in the window hierarchy, 
  which is the window object of the host website
  4. When we have access to the topmost window object we can track for user device orientation, etc.
 */
const topmostWindowObject = window.top;

const topmostWindowLocationObject = window.location;

const topmostWindowObjectBody = topmostWindowObject.document.body;

/**
 * Returns the screen width regardless of device orientation.
 *
 * @return {number} the width as width when the orientation is portrait
 * and height as width when the orientation is landscape on mobile and
 * tablet
 */
const getActualDeviceWidth = () => {
  if (topmostWindowObject.matchMedia('(orientation: landscape)').matches) {
    return topmostWindowObject.screen.height;
  }
  return topmostWindowObject.screen.width;
};

/**
 * Detect if the device is touch screen
 * https://stackoverflow.com/a/4819886/13403295
 *
 * @return {boolean} true or false
 */
const isTouchScreen = () =>
  'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

/**
 * Return user device type
 * https://attacomsian.com/blog/javascript-detect-mobile-device
 *
 * @return {("mobile"|"desktop"|"tablet")} user device type based on User Agent,
 * screen size and touch screen
 */
exports.detectUserDeviceType = () => {
  const ua = navigator.userAgent;
  const deviceWidth = getActualDeviceWidth();

  if (
    /(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua) ||
    (deviceWidth >= 768 && deviceWidth <= 1024 && isTouchScreen())
  ) {
    return 'tablet';
  }

  if (
    /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    ) ||
    (deviceWidth < 768 && isTouchScreen())
  ) {
    return 'smartphone';
  }

  return 'desktop';
};

/**
 * Determines if the user is a club member of the Torpedo7 by checking if the class names
 * of the <body> element in the topmost window object contain the string 'logged-in' and
 * if the origin of the topmost window's location object is T7's origin.
 *
 * @function
 * @returns {boolean} - True if the user is a Torpedo7 Club member and the origin
 * of the topmost window location object is https://www.torpedo7.co.nz, false otherwise.
 */
exports.detectTorpedo7ClubMember = () => {
  const regex = /\blogged-in\b/;

  const classNamesString = topmostWindowObjectBody.className;

  return (
    !!regex.test(classNamesString) &&
    topmostWindowLocationObject.origin === 'https://www.torpedo7.co.nz'
  );
};



// WEBPACK FOOTER //
// ./src/reducers/connection/utils.js